import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { SBA } from '../theme';

export default function ChangePasswordModal({ onClose }) {
  const { changePassword } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('New password and confirmation do not match.');
      return;
    }
    setSaving(true);
    try {
      await changePassword(currentPassword, newPassword);
      setDone(true);
      setTimeout(onClose, 1400);
    } catch (err) {
      console.error(err);
      const code = err?.code || '';
      if (code === 'auth/wrong-password' || code === 'auth/invalid-credential') {
        setError('Current password is incorrect.');
      } else if (code === 'auth/weak-password') {
        setError('New password is too weak.');
      } else {
        setError(err?.message || 'Could not change password. Try again.');
      }
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={m.overlay} onClick={onClose}>
      <div style={m.modal} onClick={(e) => e.stopPropagation()}>
        <div style={m.head}>
          <h2 style={m.title}>Change password</h2>
          <button type="button" style={m.close} onClick={onClose} aria-label="Close">
            <span className="material-symbols-outlined" style={{ fontSize: 20 }}>close</span>
          </button>
        </div>

        {done ? (
          <div style={m.success}>
            <span className="material-symbols-outlined" style={{ fontSize: 20 }}>check_circle</span>
            Password changed successfully.
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={m.form}>
            <label style={m.label}>
              Current password
              <input
                type="password"
                style={m.input}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>
            <label style={m.label}>
              New password
              <input
                type="password"
                style={m.input}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </label>
            <label style={m.label}>
              Confirm new password
              <input
                type="password"
                style={m.input}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </label>

            {error ? <div style={m.error}>{error}</div> : null}

            <button type="submit" disabled={saving} style={m.saveBtn(saving)}>
              {saving ? 'Changing…' : 'Change password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const m = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: 16,
  },
  modal: {
    background: '#fff',
    borderRadius: 18,
    padding: 24,
    width: '100%',
    maxWidth: 420,
    boxShadow: '0 24px 64px rgba(15,23,42,0.3)',
  },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  title: { margin: 0, fontSize: 18, fontWeight: 800, color: SBA.navy },
  close: {
    border: 'none',
    background: '#f1f5f9',
    borderRadius: 10,
    width: 34,
    height: 34,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#475569',
  },
  form: { display: 'grid', gap: 12 },
  label: { display: 'grid', gap: 6, fontSize: 12, fontWeight: 700, color: '#475569' },
  input: {
    padding: '11px 12px',
    borderRadius: 10,
    border: '1.5px solid #e2e8f0',
    fontSize: 14,
  },
  error: {
    padding: '10px 12px',
    borderRadius: 10,
    background: '#fef2f2',
    color: '#b91c1c',
    fontSize: 13,
    fontWeight: 600,
  },
  success: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 14px',
    borderRadius: 10,
    background: '#ecfdf5',
    color: '#047857',
    fontSize: 14,
    fontWeight: 700,
  },
  saveBtn: (disabled) => ({
    marginTop: 4,
    padding: '13px 16px',
    borderRadius: 12,
    border: 'none',
    background: disabled ? '#94a3b8' : SBA.navy,
    color: '#fff',
    fontWeight: 800,
    fontSize: 14,
    cursor: disabled ? 'not-allowed' : 'pointer',
  }),
};
